
// under-line-anchore-tag==============

document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('.footer-bottom-link-menu-area ul li a, main-menu-list li a');
    
    // Apply the stored class if a link was previously clicked
    const activeLink = localStorage.getItem('activeLink');
    if (activeLink) {
      document.querySelectorAll('.footer-bottom-link-menu-area ul li a, main-menu-list ul li a').forEach(function(anchor)
 {
        if (anchor.href === activeLink) {
          anchor.classList.add('your-class-name');
        }
      });
    }

    anchors.forEach(function(anchor)
 {
      anchor.addEventListener('click', function() {
        // Remove the class from all anchors
        anchors.forEach(function(anchor)
 {
          anchor.classList.remove('your-class-name');
        });

        // Add the class to the clicked anchor
        this.classList.add('your-class-name');

        // Store the clicked link's URL
        localStorage.setItem('activeLink', this.href);
      });
    });
  });



document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('.main-menu-list li a');
    
    // Apply the stored class if a link was previously clicked
    const activeLink = localStorage.getItem('activeLink');
    if (activeLink) {
      document.querySelectorAll('.main-menu-list li a').forEach(function(anchor)
 {
        if (anchor.href === activeLink) {
          anchor.classList.add('next-class-name');
        }
      });
    }

    anchors.forEach(function(anchor)
 {
      anchor.addEventListener('click', function() {
        // Remove the class from all anchors
        anchors.forEach(function(anchor)
 {
          anchor.classList.remove('next-class-name');
        });

        // Add the class to the clicked anchor
        this.classList.add('next-class-name');

        // Store the clicked link's URL
        localStorage.setItem('activeLink', this.href);
      });
    });
  });



/*------ for animations ------*/
$(document).ready(function () {
  // Select the h1 element by its tag name
  var heading = $('.main-banner-content h1');

  // Add a class to the h1 element
  heading.addClass('highlight');

  const elementsToAnimate = $('p, h2, h1');
  const observerOptions = { threshold: 0.5 };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        activateAnimation($(entry.target));
      }
    });
  }, observerOptions);

  elementsToAnimate.each(function () {
    observer.observe($(this)[0]);
  });

  function activateAnimation(element) {
    if (element.prop('tagName').toLowerCase() === 'img') {
      element.addClass("scale-animation");
    } else {
      element.addClass("animate");
    }
    observer.unobserve(element[0]);
  }
});



//   timeline
// Timeline Scroll Section
// --------------------------------------------------------------
var items = $(".v-timeline li"),
timelineHeight = $(".v-timeline ul").height(),
greyLine = $('.default-line'),
lineToDraw = $('.draw-line');

// sets the height that the greyLine (.default-line) should be according to `.v-timeline ul` height

// run this function only if draw line exists on the page
if(lineToDraw.length) {
  $(window).on('scroll', function () {

    // Need to constantly get '.draw-line' height to compare against '.default-line'
    var redLineHeight = lineToDraw.height(),
    greyLineHeight = greyLine.height(),
    windowDistance = $(window).scrollTop(),
    windowHeight = $(window).height() / 2,
    timelineDistance = $(".v-timeline").offset().top;

    if(windowDistance >= timelineDistance - windowHeight) {
      line = windowDistance - timelineDistance + windowHeight;

      if(line <= greyLineHeight) {
        lineToDraw.css({
          'height' : line + 20 + 'px'
        });
      }
    }

    // This takes care of adding the class in-view to the li:before items
    var bottom = lineToDraw.offset().top + lineToDraw.outerHeight(true);
    items.each(function(index){
      var circlePosition = $(this).offset();

      if(bottom > circlePosition.top) {				
        $(this).addClass('in-view');
      } else {
        $(this).removeClass('in-view');
      }
    });	
  });
}


$('.responsive').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
  nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>',
  responsive: [
    {
      breakpoint: 920,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
        nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>'
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
        nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>'
      }
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
        nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>'
      }
    }
  ]
});



// $('#tab1').click(function(){

//   jQuery('button.responsive-slick-prev.slick-arrow').click()
// })

$('.second-responsive').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
  nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>',
  responsive: [
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
        nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>'
      }
    }
  ]
});


$('#tab2').click(function(){

  jQuery('button.responsive-slick-prev.slick-arrow').click()
})

if ($(window).width() <= 768) {
  $('.next-responsive').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
    nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>',
    responsive: [
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: '<button type="button" class="responsive-slick-prev"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
          nextArrow: '<button type="button" class="responsive-slick-next"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.png?v=1724959397"></button>'
        }
      }
    ]
  });
}





// hamberguer-cde======================
$(document).ready(function() {
    $('.hamberguer-area').click(function() {
        $('.header-nav-links').toggleClass('open-mob-menu');
        $('.hamberguer-area').toggleClass('cross-hamburger')
        $('html').toggleClass('my-body')
    });
});

$(document).ready(function() {
    $('ul.main-menu-list .inner-menu-arrow-desktop, ul.main-menu-list .inner-menu-arrow-mob').click(function() {
        $('.sub-menu-list').addClass('my-own-ahtisham');
    });

    $('.sub-menu-inner-arrow').click(function() {
        $('.sub-menu-list').removeClass('my-own-ahtisham');
    });
});

// header-scroll-add-class

// Get the header element
// Get the header element
const header = document.querySelector('header');

// Function to add/remove class based on scroll position
function toggleHeaderClass() {
    if (window.scrollY > 0) {
        header.classList.add('scrolled'); // Add class 'scrolled' to header
    } else {
        header.classList.remove('scrolled'); // Remove class 'scrolled' from header
    }
}

// Listen for the scroll event on the window
window.addEventListener('scroll', toggleHeaderClass);




//   ================equal-height================

window.addEventListener('DOMContentLoaded', function() {
    var divs = document.querySelectorAll('.index-ingradient-heading');
    var maxHeight = 0;

    // Find the maximum height among all divs
    divs.forEach(function(div) {
        maxHeight = Math.max(maxHeight, div.offsetHeight);
    });

    // Set the minimum height for all divs
    divs.forEach(function(div) {
        div.style.minHeight = maxHeight + 'px';
    });
});



$(document).ready(function() {
    if ($(window).width() < 651) {
        $('.footer-bottom-link-menu-area h4').click(function() {
            $(this).next().slideToggle();
            $(this).toggleClass('toggled-heading');
        });
    }

    // Re-check the screen size on window resize
    $(window).resize(function() {
        if ($(window).width() < 651) {
            $('.footer-bottom-link-menu-area h4').off('click').on('click', function() {
                $(this).next().slideToggle();
                $(this).toggleClass('toggled-heading');
            });
        } else {
            $('.footer-bottom-link-menu-area h4').off('click');
        }
    });
});

$(document).ready(function() {
    // Hide all tab content initially
    $(".tabcontent").hide();

    // Show the first tab content by default
    $("#Tab1").show();
    $(".tablinks[data-tab='Tab1']").addClass("active");

    // Handle click event on tab buttons
    $(".tablinks").click(function() {
        var tabName = $(this).data("tab");

        // Hide all tab content
        $(".tabcontent").hide();

        // Remove active class from all buttons
        $(".tablinks").removeClass("active");

        // Show the selected tab content
        $("#" + tabName).show();

        // Add active class to the clicked button
        $(this).addClass("active");
    });
});


$('.slider-nav').slick({
    // slidesToShow: 3,
    // slidesToScroll: 1,
    // asNavFor: '.slider-for',
    // dots: true,
    // centerMode: true,
    // focusOnSelect: true
    slidesToShow: 8,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    infinite: false,
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
});
$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: true,
    fade: true,
    asNavFor: '.slider-nav',
    // nextArrow: true,
    // prevArrow: true,
    prevArrow: '<button type="button" class="custom-prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
    nextArrow: '<button type="button" class="custom-next-arrow"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/Vector_2.svg?v=1724959397"></button>',
});


// blog-slider

$('.multiple-items').slick({
    infinite: false,
    slidesToShow: 7,
    arrows: true,
    slidesToScroll: 1,
    prevArrow: '<button type="button" class="custom-prev-arrow"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/blog-arrow-1.svg?v=1721663215" alt="Previous"></button>',
    nextArrow: '<button type="button" class="custom-next-arrow"><img src="https://cdn.shopify.com/s/files/1/0888/9902/7232/files/blog-arrow-2.svg?v=1721663214" alt="Next"></button>',
    responsive: [
        {
            breakpoint: 1181,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
  });

// ==================equal-height
window.addEventListener('DOMContentLoaded', function() {
    var divs = document.querySelectorAll('.main-blog-content-area');
    var maxHeight = 0;

    // Find the maximum height among all divs
    divs.forEach(function(div) {
        maxHeight = Math.max(maxHeight, div.offsetHeight);
    });

    // Set the minimum height for all divs
    divs.forEach(function(div) {
        div.style.minHeight = maxHeight + 'px';
    });
});



window.addEventListener('DOMContentLoaded', function() {
    var divs = document.querySelectorAll('.contact-services-holder');
    var maxHeight = 0;

    // Find the maximum height among all divs
    divs.forEach(function(div) {
        maxHeight = Math.max(maxHeight, div.offsetHeight);
    });

    // Set the minimum height for all divs
    divs.forEach(function(div) {
        div.style.minHeight = maxHeight + 'px';
    });
});


window.addEventListener('DOMContentLoaded', function() {
    var divs = document.querySelectorAll('body.gradient.article .index-blog-content');
    var maxHeight = 0;

    // Find the maximum height among all divs
    divs.forEach(function(div) {
        maxHeight = Math.max(maxHeight, div.offsetHeight);
    });

    // Set the minimum height for all divs
    divs.forEach(function(div) {
        div.style.minHeight = maxHeight + 'px';
    });
});


document.querySelector('.hamberguer-area').addEventListener('click', function() {
  document.querySelector('header').classList.toggle('color-changes');
});


//  $(document).ready(function(){
//     // When any anchor inside the .plant-different-icon-img-content div is clicked
//     $('.plant-different-icon-img-content a').click(function(e) {
//         e.preventDefault(); // Prevent default anchor action

//         // Get the class of the clicked anchor
//         let tagClass = $(this).attr('class').split(' ')[0];

//         // Hide all blog divs
//         $('.main-blog-box').hide();

//         // Show the corresponding blog div with the same class
//         if ($('.main-blog-box.' + tagClass).length) {
//             $('.main-blog-box.' + tagClass).show();
//         } else {
//             // If no matching blog div is found, hide all blog divs
//             $('.main-blog-box').hide();
//         }
//     });
// });


$(document).ready(function(){
    // When any anchor inside the .plant-different-icon-img-content div is clicked
    $('.plant-different-icon-img-content a').click(function(e) {
        e.preventDefault(); // Prevent default anchor action

        // Get the class(es) of the clicked anchor (split by comma and space if present)
        let tagClasses = $(this).attr('class').split(', ');

        // Hide all blog divs
        $('.main-blog-box').hide();

        // Loop through each class and show the corresponding blog div
        tagClasses.forEach(function(tagClass) {
            // Show the blog div that has the matching class
            if ($('.main-blog-box.' + tagClass).length) {
                $('.main-blog-box.' + tagClass).show();
            }
        });
    });
});



// $(document).ready(function(){
//     // When any anchor inside the .plant-different-icon-img-content div is clicked
//     $('.blog-name-holder a').click(function(e) {
//      $(this).addClass('highlighted')
//       $(this).closest('.slick-slide').nextAll('.slick-slide').find('a').removeClass('highlighted');
//       $(this).closest('.slick-slide').prevAll('.slick-slide').find('a').removeClass('highlighted');
      
      
//         e.preventDefault(); // Prevent default anchor action

//         // Get the class of the clicked anchor
//         let tagClass = $(this).attr('class').split(' ')[0];

//         // Hide all blog divs
//         $('.main-blog-box').hide();

//         // Show the corresponding blog div with the same class
//         if ($('.main-blog-box.' + tagClass).length) {
//             $('.main-blog-box.' + tagClass).show();
//         } else {
//             // If no matching blog div is found, hide all blog divs
//             $('.main-blog-box').hide();
//         }
//     });
// });


$(document).ready(function(){
    // When any anchor inside the .plant-different-icon-img-content div is clicked
    $('.blog-name-holder a').click(function(e) {
        $(this).addClass('highlighted');
        $(this).closest('.slick-slide').nextAll('.slick-slide').find('a').removeClass('highlighted');
        $(this).closest('.slick-slide').prevAll('.slick-slide').find('a').removeClass('highlighted');
        
        e.preventDefault(); // Prevent default anchor action

        // Get the class(es) of the clicked anchor and split by comma and space
        let tagClasses = $(this).attr('class').split(',').map(function(tagClass) {
            return tagClass.trim();  // Remove any extra spaces around the class names
        });

        // Hide all blog divs
        $('.main-blog-box').hide();

        // Loop through each tag class and show the corresponding blog divs
        tagClasses.forEach(function(tagClass) {
            if ($('.main-blog-box.' + tagClass).length) {
                $('.main-blog-box.' + tagClass).show();
            }
        });

        // If no matching blog div is found, hide all blog divs (this is optional)
        if (tagClasses.length === 0 || tagClasses.every(function(tagClass) {
            return $('.main-blog-box.' + tagClass).length === 0;
        })) {
            $('.main-blog-box').hide();
        }
    });
});




document.addEventListener('change', function(event) {
  // Select the dropdown element and buttons
  var selectElement = document.getElementById('Option-template--23106747760928__main-1');
  var contactButton = document.querySelector('.custom-product-contact-btn');
  var addToCartButton = document.querySelector('.product-form__submit');

  if (event.target === selectElement) {
    var selectedValue = selectElement.value;
    console.log("Selected Value:", selectedValue); // Debugging log

    if (selectedValue === '55 Gallon Drum' || selectedValue === '265 Gallon Totes') {
      contactButton.style.display = 'block'; // Show the contact button
      if (addToCartButton) {
        addToCartButton.style.display = 'none'; // Hide the Add to Cart button
      }
    } else {
      contactButton.style.display = 'none'; // Hide the contact button
      if (addToCartButton) {
        addToCartButton.style.display = 'block'; // Show the Add to Cart button
      }
    }
  }

  // Initial check to handle the default state
  updateButtonVisibility();

  // Add event listener for changes
  selectElement.addEventListener('change', updateButtonVisibility);
});

// ============smooth-sec

document.querySelectorAll('.plant-different-icon-img-content').forEach(button => {
    button.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent the default action of the link

        const targetSection = document.querySelector('.main-blog-sec');
        if (targetSection) {
            // Calculate the offset for 90% of the section's position
            const targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset;
            const scrollPosition = targetPosition - (window.innerHeight * 0.08); // Offset by 10% of the viewport height

            window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth' // Ensure smooth scrolling
            });
        }
    });
});





